export function isEmpty(arr: any[]) {
    return arr.length === 0;
}

export const shuffle = (array: any[] = []) => {
    if (isEmpty(array)) {
        return [];
    }
    for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
};

export const insert = (array: any[], el: any, index?: number) => {
    return arrayAppend(array, el, index);
};

function arrayAppend(arr: any[], el: any, index?: any) {
    let spliceArgs: any;
    index = +index;
    if (isNaN(index)) {
        index = arr.length;
    }
    spliceArgs = [index, 0];
    if (isDefined(el)) {
        spliceArgs = spliceArgs.concat(el);
    }
    arr.splice.apply(arr, spliceArgs);
    return arr;
}

function isDefined(o: any) {
    return o !== undefined;
}

export const remove = (array: any[], el: any) => {
    return arrayRemove(array, el);
};


function arrayRemove(arr: any[], value: any) {
    var i = 0;
    while (i < arr.length) {
        if (arr[i] === value) {
            arr.splice(i, 1);
        } else {
            ++i;
        }
    }
    return arr;
}

export function uniqBy(arr: any = []) {
    const uniqueArray = Array.from(new Set(arr.map((item: any) => item.id))).map(
        (id) => {
            return arr.find((item: any) => item.id === id);
        }
    );
    return uniqueArray;
}


export function mergeOverride(target: any, source: any) {
    const result = { ...target };

    for (const id in source) {
        const sourceItem = source[id];
        const targetItem = target[id];

        // chưa có -> add luôn
        if (!targetItem) {
            result[id] = sourceItem;
            continue;
        }

        // đã có -> merge sâu
        result[id] = mergeItem(targetItem, sourceItem);
    }

    return result;
}

function mergeItem(target: any, source: any) {
    const result = { ...target };

    for (const key in source) {
        const sourceVal = source[key];
        const targetVal = target[key];

        // xử lý section
        if (key === 'sections' && Array.isArray(sourceVal)) {
            const map = new Map();

            (targetVal || []).forEach((item: any) => {
                map.set(item.section, { ...item });
            });

            sourceVal.forEach((item) => {
                if (map.has(item.section)) {
                    const existing = map.get(item.section);

                    Object.keys(item).forEach((k) => {
                        if (existing[k] !== item[k]) {
                            existing[k] = item[k];
                        }
                    });
                } else {
                    map.set(item.section, { ...item });
                }
            });

            result[key] = Array.from(map.values());
        }
        // object thường
        else if (
            typeof sourceVal === 'object' &&
            sourceVal !== null &&
            !Array.isArray(sourceVal)
        ) {
            result[key] = mergeItem(targetVal || {}, sourceVal);
        }
        // primitive
        else {
            if (targetVal !== sourceVal) {
                result[key] = sourceVal;
            }
        }
    }

    return result;
}
